<template>
  <info-header-card
    :icon="customer_location.icon()"
    :header="header"
    :rows="rows"
  >
    <template v-if="!is_form" #header>
      <b-button-group class="float-right my-n1">
        <b-button
          v-show="checkPermission('edit customer contact')"
          size="sm"
          :to="editLink"
        >
          <i class="fal fa-pencil" />
        </b-button>
        <b-button
          v-show="checkPermission('delete customer contact')"
          size="sm"
          @click="deleteLocation"
        >
          <i class="fal fa-trash" />
        </b-button>
      </b-button-group>
    </template>
  </info-header-card>
</template>

<script>
import CustomerLocationModel from "@/models/crm/CustomerLocationModel";
import InfoHeaderCard from "@/components/shared/InfoHeaderCard";
import { AccessControlCheck } from "@/auth/AccessControlCheck";

export default {
  name: "CustomerLocationCard",
  components: {
    InfoHeaderCard,
  },
  props: {
    customer_location: {
      type: Object,
      default: () => new CustomerLocationModel(),
    },
    is_form: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    editLink() {
      const { customer_id, id } = this.customer_location;

      return `/customer/${customer_id}/locations/${id}/edit`;
    },
    header() {
      const { type } = this.customer_location;

      return `${type ? type.toUpperCase() : "Billing"} Address`;
    },
    rows() {
      const { city, country, postal_code, region, street_address } =
        this.customer_location;
      const location_city = [city, region, country].filter((item) => item);

      return [
        {
          label: null,
          value: street_address ? street_address : "TBD",
        },
        {
          label: null,
          value: location_city.length ? location_city.join(", ") : "TBD",
        },
        {
          label: null,
          value: postal_code ? postal_code : "TBD",
        },
      ];
    },
  },
  methods: {
    checkPermission(permission) {
      return AccessControlCheck.checkPermission(permission);
    },
    deleteLocation() {
      return this.deleteModel(
        this.customer_location,
        this.customer_location.street_address
      );
    },
  },
};
</script>
